module.exports = __webpack_public_path__ + "img/gb.5db9fea0.svg";